import { CaseTypeCategory, QuestionnaireItemFormat } from '../types';

export const DEFAULT_PAGINATION_SETTINGS = {
  size: 10,
  page: 1,
  count: true,
};

export const ROWS_PER_PAGE_OPTIONS = [20, 50, 100];

export const NETSUITE_LABEL = 'Netsuite';

export const US_STATES_LIST = [
  {
    id: 'AL',
    label: 'Alabama',
  },
  {
    id: 'AK',
    label: 'Alaska',
  },
  {
    id: 'AZ',
    label: 'Arizona',
  },
  {
    id: 'AR',
    label: 'Arkansas',
  },
  {
    id: 'CA',
    label: 'California',
  },
  {
    id: 'CO',
    label: 'Colorado',
  },
  {
    id: 'CT',
    label: 'Connecticut',
  },
  {
    id: 'DC',
    label: 'District of Columbia',
  },
  {
    id: 'DE',
    label: 'Delaware',
  },
  {
    id: 'FL',
    label: 'Florida',
  },
  {
    id: 'GA',
    label: 'Georgia',
  },
  {
    id: 'HI',
    label: 'Hawaii',
  },
  {
    id: 'ID',
    label: 'Idaho',
  },
  {
    id: 'IL',
    label: 'Illinois',
  },
  {
    id: 'IN',
    label: 'Indiana',
  },
  {
    id: 'IA',
    label: 'Iowa',
  },
  {
    id: 'KS',
    label: 'Kansas',
  },
  {
    id: 'KY',
    label: 'Kentucky',
  },
  {
    id: 'LA',
    label: 'Louisiana',
  },
  {
    id: 'ME',
    label: 'Maine',
  },
  {
    id: 'MD',
    label: 'Maryland',
  },
  {
    id: 'MA',
    label: 'Massachusetts',
  },
  {
    id: 'MI',
    label: 'Michigan',
  },
  {
    id: 'MN',
    label: 'Minnesota',
  },
  {
    id: 'MS',
    label: 'Mississippi',
  },
  {
    id: 'MO',
    label: 'Missouri',
  },
  {
    id: 'MT',
    label: 'Montana',
  },
  {
    id: 'NE',
    label: 'Nebraska',
  },
  {
    id: 'NV',
    label: 'Nevada',
  },
  {
    id: 'NH',
    label: 'New Hampshire',
  },
  {
    id: 'NJ',
    label: 'New Jersey',
  },
  {
    id: 'NM',
    label: 'New Mexico',
  },
  {
    id: 'NY',
    label: 'New York',
  },
  {
    id: 'NC',
    label: 'North Carolina',
  },
  {
    id: 'ND',
    label: 'North Dakota',
  },
  {
    id: 'OH',
    label: 'Ohio',
  },
  {
    id: 'OK',
    label: 'Oklahoma',
  },
  {
    id: 'OR',
    label: 'Oregon',
  },
  {
    id: 'PA',
    label: 'Pennsylvania',
  },
  {
    id: 'RI',
    label: 'Rhode Island',
  },
  {
    id: 'SC',
    label: 'South Carolina',
  },
  {
    id: 'SD',
    label: 'South Dakota',
  },
  {
    id: 'TN',
    label: 'Tennessee',
  },
  {
    id: 'TX',
    label: 'Texas',
  },
  {
    id: 'UT',
    label: 'Utah',
  },
  {
    id: 'VT',
    label: 'Vermont',
  },
  {
    id: 'VA',
    label: 'Virginia',
  },
  {
    id: 'WA',
    label: 'Washington',
  },
  {
    id: 'WV',
    label: 'West Virginia',
  },
  {
    id: 'WI',
    label: 'Wisconsin',
  },
  {
    id: 'WY',
    label: 'Wyoming',
  },
];

export const CLIENT_ACTIVATION_TRIGGER_OPTIONS = {
  sendAppInviteUpon: [{ id: 'case', label: 'Case Creation' }],
  createWalletUpon: [{ id: 'settlement', label: 'First Settlement' }],
  issueVirtualCardUpon: [{ id: 'issueVirtual', label: 'Not Applicable (Physical Only)' }],
  issuePhysicalCardUpon: [{ id: 'issuePhysical', label: 'First Settlement' }],
};

export const ROLE_OPTIONS = [
  {
    id: 'FirmAdmins',
    label: 'Admin',
  },
];

export const CLIENT_ACTIVATION_BUTTON_GROUPS = {
  app: [
    {
      buttonLabel: 'NO APP',
      buttonType: 'error',
    },
    {
      buttonLabel: 'INVITED',
      buttonType: 'warning',
    },
    {
      buttonLabel: 'ACTIVATED',
      buttonType: 'success',
    },
  ],
  wallet: [
    {
      buttonLabel: 'NO WALLET',
      buttonType: 'error',
    },
    {
      buttonLabel: 'CREATED',
      buttonType: 'warning',
    },
    {
      buttonLabel: 'FUNDED',
      buttonType: 'success',
    },
  ],
  virtualCard: [
    {
      buttonLabel: 'NO VIRTUAL',
      buttonType: 'error',
    },
    {
      buttonLabel: 'ISSUED',
      buttonType: 'warning',
    },
    {
      buttonLabel: 'ACTIVATED',
      buttonType: 'success',
    },
    {
      buttonLabel: 'FUNDED',
      buttonType: 'success',
    },
  ],
  physicalCard: [
    {
      buttonLabel: 'NO PHYSICAL',
      buttonType: 'error',
    },
    {
      buttonLabel: 'ISSUED',
      buttonType: 'warning',
    },
    {
      buttonLabel: 'ACTIVATED',
      buttonType: 'success',
    },
    {
      buttonLabel: 'FUNDED',
      buttonType: 'success',
    },
  ],
};

export const CASE_TYPES = [
  {
    id: 'Pharma',
    label: 'Pharma',
  },
  {
    id: 'MedicalDevices',
    label: 'Medical Devices',
  },
  {
    id: 'Asbestos',
    label: 'Asbestos',
  },
  {
    id: 'OtherToxicExposure',
    label: 'Other Toxic Exposure',
  },
  {
    id: 'PersonalInjuryPremisesLiability',
    label: 'Personal Injury: Premises Liability',
  },
  {
    id: 'PersonalInjuryMovingVehicleInjury',
    label: 'Personal Injury: Moving Vehicle Injury',
  },
  {
    id: 'PersonalInjuryOther',
    label: 'Personal Injury: Other',
  },
  {
    id: 'DisasterLitigation',
    label: 'Disaster Litigation',
  },
];

export const CODE_MAPPING_FORMATS = [
  { id: 'Text', label: 'Text' },
  { id: 'DateRange', label: 'Date Range' },
  { id: 'Address', label: 'Address' },
  { id: 'Date', label: 'Date' },
];

export const CODE_MAPPING_CATEGORIES = [
  { id: 'Personal', label: 'Personal' },
  { id: 'Residence', label: 'Residence' },
  { id: 'Employment', label: 'Employment' },
  { id: 'Injury', label: 'Injury' },
];

export const DEDUCTION_TYPES = [ 
  {
    id: 'Lien',
    label: 'Lien',
  },
  {
    id: 'SERVICE_PROVIDER',
    label: 'Service Provider',
  },
  {
    id: 'Expense Reimbursement',
    label: 'Expense Reimbursement',
  },
];

export const SECONDARY_FIRM_ROLES_OPTIONS = [
  {
    id: 'CoCounsel',
    label: 'Co-counsel',
  },
  {
    id: 'ReferringCounsel',
    label: 'Referring Counsel',
  },
];

export const MAX_SEARCH_VALUE_LENGTH = 51;

export enum ExpectedAnswer {
  No = 'False',
  Yes = 'True',
}

export const EXPECTED_ANSWERS_OPTIONS = [
  {
    id: ExpectedAnswer.Yes,
    label: 'Yes',
  },
  {
    id: ExpectedAnswer.No,
    label: 'No',
  },
];

export const DATA_TYPES_OPTIONS = [
  {
    id: QuestionnaireItemFormat.Boolean,
    label: 'Boolean',
  },
  {
    id: QuestionnaireItemFormat.Date,
    label: 'Date',
  },
  {
    id: QuestionnaireItemFormat.DateRange,
    label: 'Date Range',
  },
  {
    id: QuestionnaireItemFormat.Text,
    label: 'Text',
  },
];

export const CASE_TYPES_CATEGORIES_OPTIONS = [
  {
    id: CaseTypeCategory.DisasterLitigation,
    label: 'Disaster Litigation',
  },
  {
    id: CaseTypeCategory.Drugs,
    label: 'Drugs',
  },
  {
    id: CaseTypeCategory.MedicalDevices,
    label: 'Medical Devices',
  },
  {
    id: CaseTypeCategory.MovingVehicleInjury,
    label: 'Moving Vehicle Injury',
  },
  {
    id: CaseTypeCategory.OtherMassTorts,
    label: 'Other Mass Torts',
  },
  {
    id: CaseTypeCategory.OtherPersonalInjury,
    label: 'Other Personal Injury',
  },
  {
    id: CaseTypeCategory.PremisesLiability,
    label: 'Premises Liability',
  },
  {
    id: CaseTypeCategory.ToxicExposure,
    label: 'Toxic Exposure',
  },
  {
    id: CaseTypeCategory.Other,
    label: 'Other',
  },
  {
    id: CaseTypeCategory.Custom,
    label: 'Custom',
  },
];

export const APP_STORE_DOWNLOAD_LINK = 'https://apps.apple.com/app/vlaw/id6470763922';
export const PLAY_STORE_DOWNLOAD_LINK =
  'https://play.google.com/store/apps/details?id=com.vlaw.vlaw';

export const UPLOAD_FILE_TYPE_OPTIONS = [
  { id: 'Defendants', label: 'Defendants' },
  { id: 'Clients', label: 'Clients' },
  { id: 'Cases', label: 'Cases' },
  { id: 'Deductions', label: 'Deductions' },
  { id: 'Settlements', label: 'Settlements' },
];

export const BANK_ACCOUNT_TYPE_OPTIONS = [
  {
    id: 'Savings',
    label: 'Savings',
  },
  {
    id: 'Checking',
    label: 'Checking',
  },
];

export const PAYMENT_METHOD_OPTIONS = [
  {
    id: 'ACH',
    label: 'ACH',
  },
  {
    id: 'CHECK',
    label: 'CHECK',
  },
  {
    id: 'V',
    label: 'V',
  }
];

export const NET_PAYMENT_METHOD_OPTIONS = [
  {
    id: 'ACH',
    label: 'ACH',
  },
  {
    id: 'CHECK',
    label: 'CHECK',
  }
];

export const ATTORNEY_PAYMENT_METHOD_OPTIONS = [
  {
    id: 'ACH',
    label: 'ACH',
  },
  {
    id: 'CHECK',
    label: 'CHECK',
  },
  {
    id: 'V-Firm',
    label: 'V-Firm',
  },
];


export const PAYEE_TYPE_OPTIONS = [
  {
    id: 'Vendor',
    label: 'Vendor',
  },
  {
    id: 'Other',
    label: 'Other',
  },
];

export const VENDOR_TYPE_OPTIONS = [
  {
    id: 'LIEN_HOLDER',
    label: 'Lien Holder',
  },
  {
    id: 'SERVICE_PROVIDER',
    label: 'Service Provider',
  },
  {
    id: 'SECONDARY_FIRM',
    label: 'Secondary Firm',
  }
];

export const INTENT_TYPE_OPTIONS = [
  {
    id: 'Pay',
    label: 'Pay',
  },
  {
    id: 'Withhold',
    label: 'Withhold',
  },
  {
    id: 'External',
    label: 'External',
  }
  
];

export const NET_INTENT_TYPE_OPTIONS = [
  {
    id: 'PAY',
    label: 'PAY',
  },
  {
    id: 'EXTERNAL',
    label: 'EXTERNAL',
  }
];

export const SEARCH_BY_OPTIONS_NETSUITE = [
  { label: 'Name', id: 'name' },
  { label: 'Internal ID', id: 'internalId' },
  { label: 'Payable Account ID', id: 'payableAccountId' },
  { label: 'Payable Account Name', id: 'payableAccountName' },
  { label: 'Tax ID', id: 'taxId' },
];

export const SEARCH_BY_OPTIONS_QUICKBOOKS = [
  { label: 'Id', id: 'Id' },
  { label: 'Display Name', id: 'DisplayName' },
  { label: 'Company Name', id: 'CompanyName' },
];

